// extracted by mini-css-extract-plugin
export var quantityInput = "_ff-0";